import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useToast } from 'primevue/usetoast';

import { authService } from '../utils/api/authService';

import { useOfflineData } from '../composables/useOfflineData';

export function useLogout() {
  const toast = useToast();
  const router = useRouter();

  const { invalidateAllData } = useOfflineData();

  const isPending = ref(false);

  async function logout() {
    isPending.value = true;
    try {
      await authService.logout();

      invalidateAllData();

      router.push('/login');
    } catch (error: any) {
      toast.add({
        severity: 'error',
        summary: 'Wystąpił błąd podczas wylogowywania',
        life: 3000,
      });
    } finally {
      isPending.value = true;
    }
  }

  return {
    logout,
    isPending,
  };
}
